module.exports = __webpack_public_path__ + "img/message.efaa0ff7.png";